const NativeSearch = await customElements.whenDefined('predictive-search-component');

class MsInlinePredictiveSearch extends NativeSearch {
  constructor() {
    super();
    const reset = this.resetSearch;
    this.resetSearch = (keepFocus = true) => {
      if (keepFocus === false) return;
      return reset(keepFocus);
    };
  }
}

if (!customElements.get('ms-inline-predictive-search')) {
  customElements.define('ms-inline-predictive-search', MsInlinePredictiveSearch);
}
